import React, { useState, useEffect, useRef } from 'react'
import { FiSearch, FiDownload, FiUpload } from 'react-icons/fi'
import {
  Chip,
  FormHelperText,
  Pagination,
  Tooltip,
  InputAdornment,
  capitalize,
} from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import api from '@/services/api'
import CardContent from '@mui/material/CardContent'
import Card from '@mui/material/Card'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ClearIcon from '@mui/icons-material/Clear'
import CheckIcon from '@mui/icons-material/Check'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  OutlinedInput,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  IconButton,
  Link,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import { toast } from 'react-toastify'
import RowsPerPageDropdown from '../RowsPerPageDropdown'
import Notfound from '../../../Notfound'
import { TableShimmer } from '../../../ShimmerUI'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'

const CouponManagementPage: React.FC = () => {
  const perPage = 10
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(10)
  const [openToggle, setOpenToggle] = useState(false)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [coupons, setcoupons] = useState<any[]>([])
  const [open, setOpen] = useState(false)
  const [error, setError] = useState('')
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [loading, setLoading] = useState(false)
  const [couponName, setcouponName] = useState('')
  const [monthlyPrice, setMonthlyPrice] = useState('')
  const [yearlyPrice, setYearlyPrice] = useState('')
  const [description, setDescription] = useState('')
  const [commission, setCommission] = useState('')
  const [openDelete, setOpenDelete] = useState(false)
  const [selectedcouponId, setSelectedcouponId] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [typeFilter, setTypeFilter] = useState<string>('')
  const [isActive, setIsActive] = useState<boolean>(false)
  const [discountType, setDiscountType] = useState('flat') // flat | percentage
  const [discountValue, setDiscountValue] = useState('')
  const [redeemBy, setRedeemBy] = useState<Date | null>(dayjs().toDate())
  const [couponCode, setCouponCode] = useState('')
  const [duration, setDuration] = useState('once') // once | repeating | forever
  const [durationInMonths, setDurationInMonths] = useState('0')
  const [redemptionLimit, setRedemptionLimit] = useState('')
  const [tag, setTag] = useState('')
  const [exportLoading, setExportLoading] = useState(false)
  const [importLoading, setImportLoading] = useState(false)
  const [openImportDialog, setOpenImportDialog] = useState(false)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const prevSearchFilterRef = useRef({ searchKeyword: '', typeFilter: '' })
  const isInitialMountRef = useRef(true)

  const [validationErrors, setValidationErrors] = useState({
    couponName: false,
    description: false,
    discountValue: false,
    type: false,
    redeemBy: false,
    couponCode: false,
    durationInMonths: false,
  })
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalActive, setTotalActive] = useState(0)

  const handleOpenDialog = (coupon = null) => {
    setSelectedcouponId(null)
    setcouponName('')
    setDescription('')
    setDiscountType('flat')
    setDiscountValue('')
    setRedeemBy(dayjs().toDate())
    setCouponCode('')
    setDuration('once')
    setDurationInMonths('0')
    setRedemptionLimit('')
    setTag('')

    setOpenDialog(true)
  }

  const handleOpenToggle = (couponId: string, currentStatus: boolean) => {
    setSelectedcouponId(couponId) // Set the selected coupon to toggle
    setIsActive(currentStatus) // Set the current status of the coupon (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setValidationErrors({
      couponName: false,
      description: false,
      discountValue: false,
      type: false,
      redeemBy: false,
      couponCode: false,
      durationInMonths: false,
    })
  }

  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }

  const validateForm = () => {
    const errors = {
      couponName: !couponName.trim(),
      description: !description.trim(),
      discountValue: !discountValue.trim(),
      type: !discountType.trim(),
      redeemBy: !redeemBy,
      couponCode: !couponCode.trim(),
      durationInMonths:
        duration === 'repeating' &&
        (!durationInMonths.trim() ||
          parseInt(durationInMonths, 10) <= 0 ||
          Number.isNaN(parseInt(durationInMonths, 10))),
    }

    setValidationErrors(errors)
    return Object.values(errors).every(error => !error)
  }

  // Open confirmation dialog
  const handleOpenDelete = (couponId: string) => {
    console.log(couponId)
    setSelectedcouponId(couponId)
    setOpenDelete(true)
  }

  // Close confirmation dialog
  const handleCloseDelete = () => {
    setOpenDelete(false)
    setSelectedcouponId(null)
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
    fetchcoupons(searchKeyword, typeFilter, page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    sessionStorage.setItem('prevSize', newPageSize.toString())
    // setCurrentPage(1)
  }

  const fetchcoupons = async (
    searchKeywordParam?: string,
    typeFilterParam?: string,
    pageParam?: number
  ) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        page: pageParam || currentPage,
        limit: pageSize,
      }

      // If searchKeyword exists, add it to params
      if (searchKeywordParam?.trim()) {
        params.search = searchKeywordParam
      }

      // If typeFilter exists, add it to params
      if (typeFilterParam?.trim()) {
        params.type = typeFilterParam
      }
      const response: any = await api.get('membership/coupons', { params })

      console.log('API response:', response?.data.data)

      // Set coupons from response data
      const couponsData = response?.data.data || []
      setcoupons(couponsData)
      setTotalRecords(response?.data?.total || couponsData.length)
      setTotalPages(
        Math.ceil((response?.data?.total || couponsData.length) / pageSize)
      )
    } catch (err: any) {
      console.error('Failed to fetch coupons:', err)
      setError(err.response?.data?.message || 'Failed to fetch coupons')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  const handleAddOrUpdatecoupon = async () => {
    if (!validateForm()) return

    setLoading(true)
    try {
      const payload: any = {
        name: couponName,
        description,
        type: discountType,
        value: discountValue,
        redeem_by: redeemBy,
        coupon_code: couponCode,
        duration: duration,
        duration_in_months:
          duration === 'repeating' ? parseInt(durationInMonths, 10) || 0 : 0,
        tag: tag,
      }

      if (redemptionLimit && parseInt(redemptionLimit) > 0) {
        payload.max_redemptions = parseInt(redemptionLimit)
      }

      if (selectedcouponId) {
        await api.put(`/membership/coupon/${selectedcouponId}`, payload)
        toast.success('Coupon updated successfully!')
      } else {
        await api.post('/membership/coupon', payload)
        toast.success('Coupon created successfully!')
      }

      handleCloseDialog()
      fetchcoupons(searchKeyword, typeFilter)

      // Reset fields
      setcouponName('')
      setDescription('')
      setDiscountType('flat')
      setDiscountValue('')
      setRedeemBy(dayjs().toDate())
      setCouponCode('')
      setDuration('once')
      setDurationInMonths('0')
      setRedemptionLimit('')
      setTag('')
    } catch (error: any) {
      console.error('Error creating/updating coupon:', error)
      toast.error(error.response?.data?.message || 'Failed to save coupon')
    } finally {
      setLoading(false)
    }
  }

  const handleConfirmDelete = async () => {
    if (!selectedcouponId) return
    setLoading(true)
    try {
      const response = await api.delete(
        `/membership/coupon/${selectedcouponId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      )

      toast.success('coupon deleted successfully!')
      handleCloseDelete()
      fetchcoupons(searchKeyword, typeFilter) // Refresh the coupon list
    } catch (error) {
      console.error('Error deleting coupon:', error)
      toast.error('Failed to delete coupon.')
    } finally {
      setLoading(false)
    }
  }

  const handleConfirmToggle = async () => {
    if (!selectedcouponId) return // Exit if no coupon is selected
    setLoading(true) // Start loading

    const newStatus = isActive ? 'inactive' : 'active' // Toggle the status
    try {
      const response = await api.patch(
        `membership/coupon-status/${selectedcouponId}`,
        {
          status: newStatus,
        }
      )

      if (response.status === 200) {
        setIsActive(!isActive) // Toggle status locally
        toast.success(`coupon status updated to ${newStatus}`)
      }

      setOpenToggle(false) // Close dialog after success
      fetchcoupons(searchKeyword, typeFilter) // Refresh the coupon list after updating status
    } catch (error) {
      console.error('Error updating the coupon status:', error)
      toast.error('Failed to update coupon status')
    } finally {
      setLoading(false) // Stop loading
    }
  }
  const handleReset = () => {
    setSearchKeyword('')
    setSelectedAccountStatus('')
    setTypeFilter('')
    setCurrentPage(1)
  }

  const handleExport = async () => {
    setExportLoading(true)
    try {
      const response = await api.get('membership/coupons/export', {
        responseType: 'blob',
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type:
          response.headers['content-type'] ||
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition']
      let filename = 'coupons.xlsx'
      if (contentDisposition) {
        // Try RFC 5987 format first: filename*=UTF-8''filename.ext
        let filenameMatch = contentDisposition.match(
          /filename\*=UTF-8''([^;]+)/i
        )
        if (filenameMatch) {
          try {
            filename = decodeURIComponent(filenameMatch[1].trim())
          } catch (e) {
            // If decoding fails, use the raw value
            filename = filenameMatch[1].trim()
          }
        } else {
          // Try quoted filename: filename="filename.ext"
          filenameMatch = contentDisposition.match(/filename="([^"]+)"/i)
          if (filenameMatch) {
            filename = filenameMatch[1].trim()
          } else {
            // Try unquoted filename: filename=filename.ext
            filenameMatch = contentDisposition.match(/filename=([^;\s]+)/i)
            if (filenameMatch) {
              filename = filenameMatch[1].trim()
            }
          }
        }
        // Clean up filename: remove trailing underscores, spaces, and other unwanted characters
        filename = filename.replace(/[_\s]+$/, '').replace(/^[_\s]+/, '')
      }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error: any) {
      console.error('Error exporting coupons:', error)
      toast.error(
        error.response?.data?.message || 'Failed to export coupons data'
      )
    } finally {
      setExportLoading(false)
    }
  }

  const handleImportClick = () => {
    setOpenImportDialog(true)
    setSelectedFile(null)
  }

  const handleCloseImportDialog = () => {
    setOpenImportDialog(false)
    setSelectedFile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    // Validate file type (accept only .xlsx)
    const validExtensions = ['.xlsx']
    const fileExtension = file.name
      .substring(file.name.lastIndexOf('.'))
      .toLowerCase()

    if (!validExtensions.includes(fileExtension)) {
      toast.error('Please upload a valid Excel file (.xlsx)')
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      return
    }

    setSelectedFile(file)
  }

  const handleUploadFromDialog = async () => {
    if (!selectedFile) {
      toast.error('Please select a file to upload')
      return
    }

    setImportLoading(true)
    try {
      const formData = new FormData()
      formData.append('file', selectedFile)

      await api.post('membership/coupons/upload-csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 0, // No timeout for file uploads
      })

      toast.success('Coupons imported successfully!')
      handleCloseImportDialog()
      // Refresh the coupon list
      fetchcoupons(searchKeyword, typeFilter)
    } catch (error: any) {
      console.error('Error importing coupons:', error)
      toast.error(error.response?.data?.message || 'Failed to import coupons')
    } finally {
      setImportLoading(false)
    }
  }

  const handleDownloadSample = () => {
    // Create sample data matching the structure from the screenshot
    const sampleData = [
      {
        name: 'Latest-discount-10',
        code: 'LPOSC10',
        type: 'flat',
        value: 10,
        duration: 'once',
        duration_in_months: '',
        max_redemption: 5,
        tag: 'HelloFriend1',
        description: 'Test1',
      },
      {
        name: 'Latest-discount-20',
        code: 'LPOSC20',
        type: 'percentage',
        value: 20,
        duration: 'once',
        duration_in_months: '',
        max_redemption: 5,
        tag: 'HelloFriend2',
        description: 'Test2',
      },
      {
        name: 'Latest-discount-30',
        code: 'LPOSC30',
        type: 'flat',
        value: 30,
        duration: 'repeating',
        duration_in_months: 3,
        max_redemption: 5,
        tag: 'HelloFriend3',
        description: 'Test3',
      },
      {
        name: 'Latest-discount-40',
        code: 'LPOSC40',
        type: 'flat',
        value: 40,
        duration: 'forever',
        duration_in_months: '',
        max_redemption: 5,
        tag: 'HelloFriend4',
        description: 'Test4',
      },
    ]

    // Create a new workbook
    const wb = XLSX.utils.book_new()

    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(sampleData)

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Coupons')

    // Generate Excel file and download
    XLSX.writeFile(wb, 'coupon_import_sample.xlsx')
  }

  // Single useEffect to handle search, filter, page, and pageSize changes
  useEffect(() => {
    // const searchChanged =
    //   prevSearchFilterRef.current.searchKeyword !== searchKeyword
    // const filterChanged = prevSearchFilterRef.current.typeFilter !== typeFilter

    // // Update ref
    // prevSearchFilterRef.current = { searchKeyword, typeFilter }

    // // If search or filter changed (and not initial mount), reset to page 1 and fetch
    // if ((searchChanged || filterChanged) && !isInitialMountRef.current) {
    //   setCurrentPage(1)
    //   fetchcoupons(searchKeyword, 1, pageSize, typeFilter)
    //   return
    // }

    // // Mark initial mount as complete after first render
    // if (isInitialMountRef.current) {
    //   isInitialMountRef.current = false
    // }

    // Fetch with current values (initial mount or page/pageSize changed)
    fetchcoupons(searchKeyword, typeFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword, typeFilter, pageSize])

  return (
    <div className="p-6 mx-auto max-w-7xl">
      {/* Header + Search + Export */}
      <div className="flex flex-col items-start justify-between gap-4 mb-6 sm:flex-row sm:items-center">
        <h1 className="text-2xl font-semibold text-[#6E7B8B]">Coupons</h1>
        <div className="flex items-center gap-2">
          <Button
            variant="outlined"
            startIcon={<FiUpload />}
            onClick={handleImportClick}
            disabled={importLoading}
            sx={{
              borderColor: '#5BC0BE',
              color: '#5BC0BE',
              '&:hover': {
                borderColor: '#49a9a7',
                backgroundColor: 'rgba(91, 192, 190, 0.04)',
              },
            }}
          >
            {importLoading ? 'Importing...' : 'Import'}
          </Button>
          <Button
            variant="contained"
            startIcon={<FiDownload />}
            onClick={handleExport}
            disabled={exportLoading}
            sx={{
              backgroundColor: '#5BC0BE',
              '&:hover': {
                backgroundColor: '#49a9a7',
              },
            }}
          >
            {exportLoading ? 'Exporting...' : 'Export'}
          </Button>
        </div>
      </div>

      {/* Hidden file input for import */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />

      <Card
        sx={{
          height: '100%',
          cursor: 'pointer',
          boxShadow: 2,
          padding: 2,
          mb: 3,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        <CardContent>
          <div className="grid items-end grid-cols-1 gap-4 md:grid-cols-5">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Search coupon
              </label>
              <input
                type="text"
                value={searchKeyword}
                onChange={e => setSearchKeyword(e.target.value)}
                placeholder="Search coupon"
                className="w-full border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Filter by Type
              </label>
              <FormControl fullWidth size="small">
                <Select
                  value={typeFilter}
                  onChange={e => setTypeFilter(e.target.value)}
                  displayEmpty
                  sx={{
                    height: '38px',
                    '& .MuiSelect-select': {
                      padding: '8px 14px',
                    },
                  }}
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="percentage">Percentage</MenuItem>
                  <MenuItem value="flat">Flat</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="flex items-center space-x-2">
              {/* Reset Button next to Account Status dropdown */}
              <Box display="flex" alignItems="center">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleReset}
                  sx={{
                    borderRadius: 2,
                    width: '113px',
                    marginTop: '24px',
                  }}
                >
                  Reset All
                </Button>
              </Box>
            </div>

            <div className="hidden col-span-1 md:block"></div>

            <div className="flex items-end justify-end mt-6">
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenDialog()}
              >
                + Add coupon
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      {/* <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-3">
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow h-35">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{totalRecords}</h2>
            <p className="text-sm text-gray-500">Total coupon</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-green-600 bg-green-100 rounded-full">
            <ListAltIcon />
          </div>
        </div>
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{totalActive}</h2>
            <p className="text-sm text-gray-500">Active coupon</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-blue-600 bg-blue-100 rounded-full">
            <CheckIcon />
          </div>
        </div>
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {totalRecords - totalActive}
            </h2>
            <p className="text-sm text-gray-500">InActive coupon</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-red-600 bg-red-100 rounded-full">
            <ClearIcon />
          </div>
        </div>
      </div> */}

      {/* coupon Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                <th className="px-6 py-3 font-medium">Name</th>
                <th className="px-6 py-3 font-medium">Coupon Code</th>
                <th className="px-6 py-3 font-medium">Tag</th>
                <th className="px-6 py-3 font-medium">Type</th>
                <th className="px-6 py-3 font-medium">Discount</th>
                <th className="px-6 py-3 font-medium">Duration</th>
                <th className="px-6 py-3 font-medium">Redemption Limit</th>
                {/* <th className="px-6 py-3 font-medium">Times Redeemed</th> */}
                {/* <th className="px-6 py-3 font-medium">Status</th> */}
                <th className="px-6 py-3 font-medium">Expiry</th>
                <th className="px-6 py-3 font-medium">Created</th>
                <th className="px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loadingForShimmer ? (
                <TableShimmer columns={12} />
              ) : coupons?.length === 0 ? (
                <tr>
                  <td colSpan={12} className="p-4 text-center">
                    <Notfound />
                  </td>
                </tr>
              ) : (
                coupons.map(coupon => {
                  // Format duration
                  const formatDuration = (couponData: any) => {
                    const durationValue = couponData.duration
                    if (durationValue === 'once') return 'Once'
                    if (durationValue === 'repeating') {
                      const months =
                        couponData.duration_in_months ||
                        couponData?.metadata?.duration_in_months
                      return months ? `Repeating (${months} mo)` : 'Repeating'
                    }
                    if (durationValue === 'forever') return 'Forever'
                    return capitalize(durationValue)
                  }

                  // Format date
                  const formatDate = (timestamp: number) => {
                    return new Date(timestamp * 1000).toLocaleDateString(
                      'en-US',
                      {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      }
                    )
                  }

                  return (
                    <tr
                      key={coupon._id || coupon.id}
                      className="transition-colors hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 font-medium">{coupon.name}</td>
                      <td className="px-6 py-4">
                        <span className="px-2 py-1 font-mono text-sm bg-gray-100 rounded">
                          {coupon.coupon_code}
                        </span>
                      </td>
                      <td className="max-w-xs px-6 py-4">
                        <div className="truncate" title={coupon.tag || ''}>
                          {coupon.tag || '-'}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <Chip
                          label={coupon.amount_off ? 'Flat' : 'Percentage'}
                          size="small"
                          color={coupon.amount_off ? 'primary' : 'secondary'}
                        />
                      </td>
                      <td className="px-6 py-4">
                        {coupon.amount_off
                          ? `$${coupon.amount_off.toFixed(2)}`
                          : coupon.percent_off
                            ? `${coupon.percent_off}%`
                            : '-'}
                        {/* {coupon.currency && coupon.amount_off && (
                          <span className="ml-1 text-xs text-gray-500">
                            {coupon.currency.toUpperCase()}
                          </span>
                        )} */}
                      </td>
                      <td className="px-6 py-4">
                        <Chip
                          label={formatDuration(coupon)}
                          size="small"
                          variant="outlined"
                        />
                      </td>
                      <td className="px-6 py-4">
                        {coupon.max_redemptions ? (
                          <span>
                            {/* <span className="font-semibold">
                              {coupon.times_redeemed || 0}
                            </span> */}
                            {/* <span className="mx-1 text-gray-400">/</span> */}
                            <span className="font-semibold">
                              {coupon.max_redemptions}
                            </span>
                          </span>
                        ) : (
                          <Chip
                            label="Unlimited"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </td>
                      {/* <td className="px-6 py-4">
                        <span className="font-semibold">
                          {coupon.times_redeemed || 0}
                        </span>
                      </td> */}
                      {/* <td className="px-6 py-4">
                        <Chip
                          label={coupon.valid ? 'Valid' : 'Invalid'}
                          size="small"
                          color={coupon.valid ? 'success' : 'error'}
                        />
                      </td> */}
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {coupon.redeem_by
                          ? dayjs(coupon.redeem_by).format('MM/DD/YYYY')
                          : 'No expiry'}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {coupon.createdAt
                          ? dayjs(coupon.createdAt).format('MM/DD/YYYY')
                          : '-'}
                      </td>
                      <td className="px-6 py-4">
                        <Tooltip title="Delete coupon" arrow>
                          <IconButton
                            onClick={() => handleOpenDelete(coupon._id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  )
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-4 mt-4 sm:flex-row">
        <RowsPerPageDropdown
          pageSize={pageSize}
          onPageSizeChange={newPageSize => {
            handlePageSizeChange(newPageSize)
          }}
        />
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event: React.ChangeEvent<unknown>, page: number) =>
            handlePageChange(event, page)
          }
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>

      {/* Add coupon Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {selectedcouponId ? 'Edit coupon' : 'Add coupon'}
        </DialogTitle>

        <DialogContent className="flex flex-col gap-4">
          <TextField
            label="Coupon Name"
            value={couponName}
            onChange={e => setcouponName(e.target.value)}
            error={validationErrors.couponName}
            helperText={
              validationErrors.couponName ? 'Coupon Name is required' : ''
            }
            fullWidth
            sx={{ mt: '5px' }}
          />

          <TextField
            label="Coupon Code"
            value={couponCode}
            onChange={e => setCouponCode(e.target.value.toUpperCase())}
            error={validationErrors.couponCode}
            helperText={
              validationErrors.couponCode ? 'Coupon Code is required' : ''
            }
            fullWidth
            placeholder="e.g., SAVE20"
          />

          <TextField
            label="Description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            multiline
            rows={3}
            fullWidth
            error={validationErrors.description}
            helperText={
              validationErrors.description ? 'Description is required' : ''
            }
          />

          <TextField
            label="Tag"
            value={tag}
            onChange={e => setTag(e.target.value)}
            fullWidth
            // placeholder="e.g., HelloFriend1"
          />

          {/* Discount Type Dropdown */}
          <FormControl fullWidth error={validationErrors.type}>
            <InputLabel>Discount Type</InputLabel>

            <Select
              value={discountType}
              label="Discount Type"
              onChange={e => {
                setDiscountType(e.target.value)
                setDiscountValue('')
              }}
            >
              <MenuItem value="flat">Flat ($)</MenuItem>
              <MenuItem value="percentage">Percentage (%)</MenuItem>
            </Select>

            {validationErrors.type && (
              <FormHelperText>Discount Type is required</FormHelperText>
            )}
          </FormControl>

          {/* Discount Value */}
          <TextField
            label={discountType === 'flat' ? 'Amount ($)' : 'Percentage (%)'}
            type="number"
            value={discountValue}
            onChange={e => {
              let v = e.target.value

              if (v === '' || parseFloat(v) < 0) {
                setDiscountValue('')
                return
              }

              if (discountType === 'percentage' && parseFloat(v) > 100) return

              if (discountType === 'flat') {
                const valid = v.match(/^(\d+(\.\d{0,2})?)?$/)
                if (!valid) return
              }

              setDiscountValue(v)
            }}
            fullWidth
            error={validationErrors.discountValue}
            helperText={
              validationErrors.discountValue
                ? 'Please enter a valid discount'
                : ''
            }
          />

          {/* Duration Dropdown */}
          <FormControl fullWidth>
            <InputLabel>Duration</InputLabel>
            <Select
              value={duration}
              label="Duration"
              onChange={e => {
                const value = e.target.value
                setDuration(value)
                if (value !== 'repeating') {
                  setDurationInMonths('0')
                  setValidationErrors(prev => ({
                    ...prev,
                    durationInMonths: false,
                  }))
                }
              }}
            >
              <MenuItem value="once">Once</MenuItem>
              <MenuItem value="repeating">Repeating</MenuItem>
              <MenuItem value="forever">Forever</MenuItem>
            </Select>
          </FormControl>

          {duration === 'repeating' && (
            <TextField
              label="Duration (months)"
              type="number"
              value={durationInMonths}
              onChange={e => {
                const value = e.target.value
                if (value === '') {
                  setDurationInMonths('')
                  return
                }
                const parsed = parseInt(value, 10)
                if (Number.isNaN(parsed) || parsed < 1) return
                setDurationInMonths(parsed.toString())
              }}
              fullWidth
              error={validationErrors.durationInMonths}
              helperText={
                validationErrors.durationInMonths
                  ? 'Duration in months is required for repeating coupons'
                  : ''
              }
              inputProps={{ min: 1 }}
              placeholder="Enter number of months"
            />
          )}

          {/* Redemption Limits */}
          <TextField
            label="Redemption limits"
            type="number"
            value={redemptionLimit}
            onChange={e => {
              const value = e.target.value
              if (
                value === '' ||
                (parseInt(value) >= 0 && parseInt(value) <= 999999)
              ) {
                setRedemptionLimit(value)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">time</InputAdornment>
              ),
            }}
            helperText="Limit the total number of times this coupon can be redeemed (leave empty for unlimited)"
            placeholder="Enter number"
          />

          {/* NEW: Expiry Date (redeem_by) */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Expiry Date"
              value={redeemBy}
              minDate={new Date()}
              onChange={newValue => {
                // Convert PickerValue (Date | Dayjs) to Date
                const dateObj = newValue instanceof Date ? newValue : (newValue as any)?.toDate ? (newValue as any).toDate() : (newValue ? new Date(newValue as any) : null)
                setRedeemBy(dateObj)
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: !!validationErrors.redeemBy,
                  helperText: validationErrors.redeemBy
                    ? 'Expiry Date is required'
                    : '',
                },
              }}
            />
          </LocalizationProvider>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={loading}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleAddOrUpdatecoupon}
            disabled={loading}
          >
            {loading
              ? 'Saving...'
              : selectedcouponId
                ? 'Update coupon'
                : 'Add coupon'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this coupon?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          coupon?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Import Coupons Dialog */}
      <Dialog
        open={openImportDialog}
        onClose={handleCloseImportDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
          Import Coupons
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body2"
            sx={{ mb: 3, color: 'text.secondary', fontSize: '0.875rem' }}
          >
            Upload coupons listing (File type .xlsx)
          </Typography>

          {/* Note about maximum coupons */}
          <Box
            sx={{
              mb: 3,
              p: 1.5,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: '0.875rem', color: 'text.secondary' }}
            >
              <strong>Note:</strong> A maximum of 20 coupons can be uploaded at
              once.
            </Typography>
          </Box>

          {/* File Upload Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Button
              variant="outlined"
              startIcon={<FiUpload />}
              onClick={() => fileInputRef.current?.click()}
              sx={{
                borderColor: '#5BC0BE',
                color: '#5BC0BE',
                '&:hover': {
                  borderColor: '#49a9a7',
                  backgroundColor: 'rgba(91, 192, 190, 0.04)',
                },
              }}
            >
              UPLOAD FILE
            </Button>
            <Link
              component="button"
              variant="body2"
              onClick={handleDownloadSample}
              sx={{
                color: '#5BC0BE',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Download Sample
            </Link>
          </Box>

          {/* Selected File Display */}
          {selectedFile && (
            <Box
              sx={{
                mt: 2,
                p: 1.5,
                backgroundColor: '#e8f5e9',
                borderRadius: 1,
                border: '1px solid #c8e6c9',
              }}
            >
              <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                Selected file: <strong>{selectedFile.name}</strong>
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleCloseImportDialog}
            disabled={importLoading}
            sx={{
              backgroundColor: '#757575',
              color: 'white',
              '&:hover': {
                backgroundColor: '#616161',
              },
            }}
          >
            CANCEL
          </Button>
          <Button
            onClick={handleUploadFromDialog}
            disabled={!selectedFile || importLoading}
            variant="contained"
            sx={{
              backgroundColor:
                selectedFile && !importLoading ? '#5BC0BE' : '#bdbdbd',
              color: 'white',
              '&:hover': {
                backgroundColor:
                  selectedFile && !importLoading ? '#49a9a7' : '#bdbdbd',
              },
            }}
          >
            {importLoading ? 'UPLOADING...' : 'UPLOAD'}
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  )
}

export default CouponManagementPage
